import React, { useCallback } from 'react';
import { defineMessages, useIntl } from 'react-intl-next';

import AiAgentIcon from '@atlaskit/icon/core/ai-agent';

import { Ati } from '@atlassian/ari';

import { useCreateAgentMenuItem } from '../../CreateContentPopover/CreateContentPopoverItems/useCreateAgentMenuItem.ts';
import { ItemTitleWithLozenge } from '../ItemTitle.tsx';

import type { UseMenuItemProps, UseMenuItemReturnProps } from './index.tsx';

const messages = defineMessages({
	title: {
		id: 'create-blank-fabric-page.universal-create.agent.title',
		defaultMessage: 'Create agent',
		description: 'Title indicating that this option will redirect to the Studio Create Agent page',
	},
	newLozenge: {
		id: 'create-blank-fabric-page.universal-create.agent.new-lozenge',
		defaultMessage: 'New',
		description: 'Text for the new lozenge indicating this is a new feature',
	},
});

export function useAgentItem({ onClick }: UseMenuItemProps): UseMenuItemReturnProps {
	const { formatMessage } = useIntl();
	const { createAgentUrl } = useCreateAgentMenuItem();

	const handleClick = useCallback(() => {
		onClick('createAgentPopoverItem');
	}, [onClick]);

	return {
		ati: Ati.parse('ati:cloud:confluence:rovo'),
		children: (
			<ItemTitleWithLozenge lozenge={formatMessage(messages.newLozenge)}>
				{formatMessage(messages.title)}
			</ItemTitleWithLozenge>
		),
		href: createAgentUrl,
		target: '_blank',
		onClick: handleClick,
		elemBefore: AiAgentIcon,
		testId: 'create-menu-link-item',
	};
}
